export * from './actions';
export * from './getters';
export * from './mutations';
export * from './state';
//form-wizards-store
export const namespaced = true;
